// @flow

import {
  selectCartOwnerList,
  selectCartUUID,
  type PartialOrganization,
} from '@gandi/cart';
import {
  selectOneOrganization,
  selectOrganizationsList,
  type Organization,
} from '@gandi/redux-organization';
import { selectCurrentId } from '@gandi/redux-sharing';

import { selectShopCurrent } from 'src/modules/organization/selectors';
import type { FullState } from 'src/types';

import { FETCH_ORGANIZATIONS_PARAMS } from './index';

export const selectOrgCountry = (state: FullState, orgId: string): string => {
  const currentId = selectCurrentId(state);
  const org =
    orgId === currentId
      ? selectShopCurrent(state, false)
      : selectOneOrganization(state, orgId);

  return org?.country || '';
};

export const selectOrgBU = (state: FullState, orgId: string): number | void => {
  const currentId = selectCurrentId(state);
  const org =
    orgId === currentId
      ? selectShopCurrent(state, false)
      : selectOneOrganization(state, orgId);

  return org ? org.bu_id : undefined;
};

export const selectShopOrgaList = (
  state: FullState,
): Array<Organization> | Array<PartialOrganization> => {
  const cartId = selectCartUUID(state);
  const organizationsList = selectOrganizationsList(
    state,
    FETCH_ORGANIZATIONS_PARAMS,
  );
  const cartOwnerList = selectCartOwnerList(state);

  return cartId ? cartOwnerList : organizationsList;
};
